import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  pauseHeroButton_svg: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    transition: "visibility 0s ease-in 0.3s",
    "&.isActive": {
      visibility: "hidden",
    }
  },
  pauseHeroButton_play: {
    fill: theme.palette.white,
    marginLeft: "5px",
    width: "1.75rem",
    height: "1.75rem"
  },
  pauseHeroButton_pause: {
    fill: theme.palette.white,
    width: "1.75rem",
    height: "1.75rem"
  },
  pauseHeroButton: {
    width: "71px",
    height: "71px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.gridPurple,
    position: "absolute",
    border: `3px solid ${theme.palette.yellow}`,
    zIndex: 99,
    bottom: "3rem",
    left: "30%",
    transform: "translatex(-50%)",
    transition: "all 0.2s ease-in-out",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100%",
    "&:hover": {
      border: `5px solid ${theme.palette.yellow}`,
      backgroundColor: theme.palette.purple
    },
    "&:focus": {
    border: `6px solid ${theme.palette.yellow}`,
      backgroundColor: theme.palette.darkPurple
    }
  },
}));
